export default __webpack_public_path__ + "static/media/shortActive.6ad8cbe0.svg";